import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Eye, EyeOff } from "lucide-react";

const COUNTRY_CODES = [
  { code: "+62", country: "Indonesia 🇮🇩" },
  { code: "+1", country: "USA/Canada 🇺🇸" },
  { code: "+44", country: "UK 🇬🇧" },
  { code: "+61", country: "Australia 🇦🇺" },
  { code: "+65", country: "Singapore 🇸🇬" },
  { code: "+60", country: "Malaysia 🇲🇾" },
  { code: "+63", country: "Philippines 🇵🇭" },
  { code: "+66", country: "Thailand 🇹🇭" },
  { code: "+84", country: "Vietnam 🇻🇳" },
  { code: "+95", country: "Myanmar 🇲🇲" },
  { code: "+855", country: "Cambodia 🇰🇭" },
  { code: "+856", country: "Laos 🇱🇦" },
  { code: "+673", country: "Brunei 🇧🇳" },
  { code: "+86", country: "China 🇨🇳" },
  { code: "+81", country: "Japan 🇯🇵" },
  { code: "+82", country: "South Korea 🇰🇷" },
  { code: "+91", country: "India 🇮🇳" },
  { code: "+92", country: "Pakistan 🇵🇰" },
  { code: "+880", country: "Bangladesh 🇧🇩" },
  { code: "+94", country: "Sri Lanka 🇱🇰" },
  { code: "+971", country: "UAE 🇦🇪" },
  { code: "+966", country: "Saudi Arabia 🇸🇦" },
  { code: "+974", country: "Qatar 🇶🇦" },
  { code: "+973", country: "Bahrain 🇧🇭" },
  { code: "+968", country: "Oman 🇴🇲" },
  { code: "+965", country: "Kuwait 🇰🇼" },
  { code: "+49", country: "Germany 🇩🇪" },
  { code: "+33", country: "France 🇫🇷" },
  { code: "+39", country: "Italy 🇮🇹" },
  { code: "+34", country: "Spain 🇪🇸" },
  { code: "+31", country: "Netherlands 🇳🇱" },
  { code: "+7", country: "Russia 🇷🇺" },
  { code: "+55", country: "Brazil 🇧🇷" },
  { code: "+52", country: "Mexico 🇲🇽" },
  { code: "+27", country: "South Africa 🇿🇦" },
  { code: "+20", country: "Egypt 🇪🇬" },
  { code: "+234", country: "Nigeria 🇳🇬" },
];

export default function Login() {
  const [countryCode, setCountryCode] = useState("+62");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const fullPhone = countryCode + phone.replace(/^0+/, "");
      const result = await login(fullPhone, password);
      if (result.ok) {
        toast.success("Login berhasil!");
        if (result.user?.role === "sub_admin" || result.user?.role === "admin") {
          nav("/admin");
        } else {
          nav("/");
        }
      } else {
        toast.error(result.error);
      }
    } catch {
      toast.error("Terjadi kesalahan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100 px-4">
      <div className="w-full max-w-md border border-black bg-white shadow-brutal">
        <div className="p-6 border-b border-black bg-black text-white">
          <div className="label-mono text-yellow-400">// ALESHOPNOW</div>
          <h1 className="font-display text-3xl font-black uppercase mt-1">Login</h1>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <label className="label-mono block mb-2">Nomor HP</label>
            <div className="flex gap-2">
              <select value={countryCode} onChange={(e) => setCountryCode(e.target.value)}
                className="input-brutal w-48 text-xs">
                {COUNTRY_CODES.map((c) => (
                  <option key={c.code} value={c.code}>{c.code} {c.country}</option>
                ))}
              </select>
              <input value={phone} onChange={(e) => setPhone(e.target.value)}
                className="input-brutal flex-1" placeholder="8xxxxxxxxxx" required />
            </div>
            <div className="font-mono text-[10px] text-zinc-500 mt-1">
              Nomor lengkap: <b>{countryCode}{phone.replace(/^0+/, "")}</b>
            </div>
          </div>

          <div>
            <label className="label-mono block mb-2">Password</label>
            <div className="relative">
              <input type={showPassword ? "text" : "password"} value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-brutal w-full pr-12" placeholder="Password kamu" required />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-black">
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "// LOADING..." : "Login →"}
          </button>

          <div className="text-center font-mono text-xs text-zinc-500">
            Belum punya akun? <Link to="/register" className="font-bold text-black underline">Daftar</Link>
          </div>
        </form>
      </div>
    </div>
  );
}